<template>
  <!-- <div style="width: 1200px; margin: auto">       -->
  <div class="storeBox">
    <div class="navHeader">
      <div class="collectButoon navHeader_right" style="width: 1200px; margin: auto">
        <div class="dashoardPage">
          <router-link to='/'><i class="el-icon-s-home blink"></i><i class="blink">商城首页</i></router-link>
        </div>
        <div>
          <el-dropdown>
            <span class="dt el-dropdown-link" style="cursor:pointer"><i class="el-icon-s-shop"></i> {{ storeInfo.name }}</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <shopStoreItem :shopInfo='storeInfo' :isshow="0"></shopStoreItem>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button ref="dataType" size="mini" icon="el-icon-chat-round" class="layui-btn site-demo-layim"
                     data-type="chat" @click="contactStore">联系卖家
          </el-button>
          <el-button @click="toggleCollect" size="mini"
                     :icon="storeInfo.isCollect === 1 ? 'el-icon-star-on' : 'el-icon-star-off'">
            {{ storeInfo.isCollect === 1 ? '取消关注' : '关注店铺' }}
          </el-button>
          <el-button size="mini" icon="el-icon-postcard" @click="navToCert">证照信息</el-button>
        </div>
      </div>
    </div>
    <!-- 店铺分类 导航栏    -->
    <div class="categorysBox" style="background: var(--main-theme-color);">
      <div class="stop-box" v-if="storeInfo && storeInfo.shutStatus === 'PUBLICITY'">
        <i class="el-icon-data-board"></i>
        <div class="text">此店铺停业整顿中，暂不支持交易!</div>
      </div>
      <div class="w w1200">
        <div class="categorys">
          <div class="categorys-type">
            <a href="javascript:;" @click="dashboardClick"><i class="el-icon-s-shop"></i> 店铺首页</a>
          </div>
        </div>
        <div class="nav-main">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="-1">店铺活动</el-menu-item>
            <el-menu-item v-for="item in navList" :key="item.sid" :index="item.sid.toString()">{{ item.name }}
            </el-menu-item>
          </el-menu>
        </div>
      </div>
    </div>
    <!-- 轮播图start -->
    <el-carousel trigger="click" height="500px" class="carouselBox" v-if="isCarousel&&swiperList.length" autoplay>
      <el-carousel-item v-for="(item) in swiperList" :key="item.id">
        <el-image :title="`${item.slideTitle}`" :src="`${item.slideLogo}`" fit="fill"
                  style="width: 100%; height: 500px">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </el-carousel-item>
    </el-carousel>
    <!-- 轮播图end -->
    <el-container class="w w1200 main-content">
      <el-aside width="180px">
        <hotGoods navTitle="热卖商品" :hotGoodsList='lefthotGoodsList'></hotGoods>
      </el-aside>
      <el-main class="no-padding">
        <ul class="orderBy">
          <li :class="{'active': formInline.sortname === 'saleNum'}"
              @click="toggleSort('saleNum')"> 热销
          </li>
          <li :class="{'active': formInline.sortname === 'price_up' || formInline.sortname === 'price_down'}"
              @click="toggleSort('price')">
            价格
            <i class="el-icon-arrow-up" v-if="formInline.sortname === 'price_up'"></i>
            <i class="el-icon-arrow-down" v-else></i>
          </li>
          <li :class="{'active': formInline.sortname === 'createTime'}"
              @click="toggleSort('createTime')"> 上新
          </li>
        </ul>
        <div class="product-list" v-if="rightGoodsList.length">
          <template v-for="item in rightGoodsList">
            <good-card :good="item" :key="item.id"></good-card>
          </template>
        </div>
        <empty v-else>暂无相关商品！</empty>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="{
          total, currentPage: formInline.pageNum, pageSize: formInline.pageSize
        }" @callFather="callFather"></Pagination>
      </el-main>
    </el-container>
    <!-- 店铺活动 开始 后续可提出作为公共部分-->
    <el-container style="margin-top:20px" v-if="isShowActivity">
      <el-row v-if="envelopeList.length>0" :gutter="20" style="width:100%" v-loading='activityLoading'>
        <el-col
          :xs="12" :sm="6" :md="6" :lg="6"
          v-for="(item,index) in envelopeList" :key="item.id" class="bigoutBox">
          <div class="wholeBox">
            <img v-if="item.icon" class="img-Activity" :src="`${item.icon}`"/>
            <div class="img-Activity" v-if="item.icon==''?true:false"><span class="noimg">暂无图片</span></div>
            <div class="text_right" style="padding: 14px 0;">
                        <span style="
                            font-size: 30px;
                            color: #d93600;
                            height: 32px;
                            margin-top: 15px;
                            ">¥<em>{{ item.bxyRedEnvelopesList[0].redenvelopesPrice }}</em></span>
              <div style="color: #d93600;font-size: 14px">满{{ item.bxyRedEnvelopesList[0].subtotal }}元可用</div>
              <el-button type="text" class="getNow" :disabled='item.flag'
                         @click="getRedEnveloped(item.bxyRedEnvelopesList[0].axyRid,item.bxyRedEnvelopesList[0].activityId)">
                立即领取
              </el-button>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row style="width:100%" v-else>
        <div class="nodate">
          <div class="first">您还没有相关的优惠券</div>
          <div class="second">店铺红包可享受商品优惠</div>
        </div>
      </el-row>
    </el-container>
    <!-- 店铺活动 结束 -->

    <!-- 点击领取后的弹框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      center
      class="dialogBox">
      <div class="textCenter">领取成功，请在有效期前使用！</div>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false" class="buttonBgd">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
import GoodCard from '@/components/good-card';
import hotGoods from '@/components/hotGoods'
import shopStoreItem from '@/components/shopStoreItem'
import "@/assets/css/base.css";
import {
  commoditylist,
  addCollection,
  removeCollection,
  storeList,
  redEnvelope,
  getredEnvelope,
  storeSwiperList,
  storeCategory,
  imUserID,
  fetchReceiverIm, fetchImToken
} from "../../api/xunyou";
import Pagination from '@/components/Pagination'
import {mapState, mapMutations} from 'vuex'
export default {
  inject: ['reload'],
  data() {
    return {
      // 店铺分类导航栏
      activeIndex: "1",
      navList: [], // 店铺分类导航栏
      secondNavList: [],
      threeNavList: [],
      level: 1, // 店铺分类级别
      isCarousel: true,
      //   店铺活动
      envelopeList: [],
      activityLoading: false,
      isShowActivity: false, // 店铺活动页面展示
      dialogVisible: false,

      userInfo: this.$store.state.userInfo,
      storeInfo: {},
      loading: false,
      centerDialogVisible: false,
      successInfo: true,
      categorylists: '',
      addGoodsName: "",
      checked1: "",
      checked2: "",
      rightGoodsList: [],
      hotGoodsTitle: '热卖商品',
      swiperList: [], // 轮播图
      lefthotGoodsList: [],
      imUserId: '',//店铺用户id
      // 查询条件是否选中
      selectTag: ["active", "", "", "", ""],
      priceSort: false,
      // 请求数据参数
      total: 0,
      formInline: {
        pageSize: 10,
        pageNum: 1,
        sid: '',
        stype: 1,
        sortway: false,
        sortname: 'saleNum'
      }
    };
  },

  components: {hotGoods, Pagination, shopStoreItem, GoodCard},
  computed: {
    storeId() {
      return this.$route.query.storeId;
    },
    userId() {
      return this.$store.getters.userId;
    }
  },
// 路由离开的时候 // 离开此页面前修改展示导航栏，否则影响其他页面
  beforeRouteLeave(to, from, next) {
    this.$store.commit('getisShowNav', true);
    next()
  },
  created() {
    this.$store.commit('getisShowNav', false)
  },
  mounted() {
    this.getStoreInfo()
    this.searchRedEnvelope()
    this.getSwiperList()
    this.getStoreCategoryList(1);
    this.getGoodsList();
    this.getImUserID()
  },
  methods: {
    navToCert () {
      this.$router.push(`/storeCert?storeId=${this.storeId}`);
    },
    // 联系商家
    contactStore() {
      this.$tools.contactService(this.storeInfo.bxmId, 'MER');
    },

    // 切换排序方式
    toggleSort(type) {
      if (type === 'price') {
        if (this.formInline.sortname === 'price_up') {
          this.formInline.sortname = 'price_down';
        } else {
          this.formInline.sortname = 'price_up';
        }
      } else {
        this.formInline.sortname = type;
      }
      this.getGoodsList();
    },
    handleSelect(key, keyPath) {
      if (key === '-1') {
        // 显示店铺活动
        this.isCarousel = true;
        this.isShowActivity = true;
      } else {
        // 点击分类
        this.isShowActivity = false;
        this.isCarousel = false;
        this.formInline.sid = key;
        this.search();
      }
    },
    // 查询店铺分类,暂时不考虑二级分类
    getStoreCategoryList() {
      storeCategory({level: 1, mid: this.storeId}).then((res) => {
        console.log('分类菜单：', res);
        if (res.code === 0) {
          this.navList = res.rows;
        }
      }).catch((err) => {
        this.$message.error("店铺商品分类失败，请稍后再试！");
      });
    },

    // 点击店铺首页
    dashboardClick() {
      this.isCarousel = true;
      this.isShowActivity = false;
      this.formInline.sid = id;
    },

    // ----------------------- 轮播图 开始 --------------------------------
    getSwiperList() {
      storeSwiperList({
        type: 1, // 1：pc;2:wap
        storeId: this.storeId,
      })
        .then((res) => {
          this.loading = false;
          this.swiperList = res.rows
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("店铺查询失败，请稍后再试！");
        });
    },
    // ----------------------- 轮播图 结束 --------------------------------

    // 店铺查询
    getStoreInfo() {
      this.loading = true;
      storeList({
        userId: this.userId,
        bxmId: this.storeId,
      }).then((res) => {
        console.log('店铺信息：', res);
        this.loading = false;
        if (res.code === 0) {
          this.storeInfo = res.rows[0];
        }
      }).catch((err) => {
        this.loading = false;
        this.$message.error("店铺查询失败，请稍后再试！");
      });
    },


    // 查询店铺的用户管理
    getImUserID() {
      imUserID({
        bxmid: this.storeId,
      }).then((res) => {
        this.imUserId = res.data.imUserId;
      }).catch((err) => {
        console.error(err);
      });
    },

    // 切换收藏状态
    toggleCollect() {
      this.$tools.isLogin(() => {
        const req = {
          type: 2, //1:商品；2：店铺；必填
          uid: this.userId,
          cid: this.storeInfo.bxmId
        }
        let promise = null;
        if (this.storeInfo.isCollect === 1) {
          this.storeInfo.isCollect = 0;
          promise = removeCollection(req);
        } else {
          this.storeInfo.isCollect = 1;
          promise = addCollection(req);
        }
        promise.then(res => {
          console.log('收藏操作结果：', res);
        });
      });
    },
    // 搜索
    search() {
      this.formInline.pageNum = 1;
      this.getGoodsList();
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.getGoodsList();
    },
    // 商品列表查询
    getGoodsList() {
      const params = {
        pageNum: this.formInline.pageNum,
        pageSize: this.formInline.pageSize,
        sid: this.formInline.sid,
        mid: this.storeId,
        stype: '',
        sortname: this.formInline.sortname,
        sortway: this.formInline.sortway
      };
      // 奇怪的逻辑：sortway只有价格升序的时候应该为TRUE；否则，会导致其它排序不起作用
      if (this.formInline.sortname === 'price_up') {
        params.sortway = true;
        params.sortname = 'price';
      }
      if (this.formInline.sortname === 'price_down') {
        params.sortway = false;
        params.sortname = 'price';
      }
      commoditylist(params).then((res) => {
        console.log("res商品列表查询", res);
        this.loading = false;
        if (res.code === 0) {
          this.rightGoodsList = res.rows;
          this.lefthotGoodsList = res.rows > 4 ? res.rows.slice(0, 4) : res.rows
          this.total = res.total;
        }
      }).catch((err) => {
        console.error(err);
        this.loading = false;
        this.$message.error("查询商品列表失败，请稍后再试！");
      });
    },

    // ------------------------------店铺活动 开始-----------------------------------
    // 活动查询
    searchRedEnvelope() {
      redEnvelope({mid: this.storeId, uid: this.userId})
        .then(res => {
          if (res.code == 0) {
            this.envelopeList = res.rows;
            this.envelopeList.forEach((item) => {
              item.isGet = false
            })
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          this.$message.error('查询红包失败，请稍后再试！')
        })
    },
    // 立即领取红包
    getRedEnveloped(aXyRid, activityId) {
      this.$tools.isLogin(() => {
        getredEnvelope({aXyRid: aXyRid, muid: this.userId, activityId: activityId})
          .then(res => {
            if (res.code == 0) {
              this.dialogVisible = true
              this.searchRedEnvelope()
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(err => {
            this.$message.error('查询红包失败，请稍后再试！')
          })
      });

    }
    //------------------------------店铺活动 开始-----------------------------------
  },
};
</script>

<style scoped lang='less'>
.main-content {
  margin-top: 10px;
}

.no-padding {
  padding: 0;
}

.orderBy {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;

  & > li {
    background: #fff;
    color: #333;
    margin-left: 10px;
    border: 1px solid #F5F5F5;
    font-size: 12px;
    padding: 2px 15px;
    line-height: 20px;
    cursor: pointer;

    &.active {
      background: var(--main-theme-color);
      font-weight: bold;
      color: #FFFFFF;
    }
  }
}

.no-padding {
  padding: 0;
}

.product-list {
  min-height: 500px;
  padding: 10px 5px;

  .product {
    margin: 0 5px 10px 5px;
  }
}


.secondNavListCss .el-dropdown-menu__item:focus, .secondNavListCss .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: var(--main-theme-color)26 !important;
  color: var(--main-theme-color) !important;
}

.navHeader {
  display: flex;
  justify-content: flex-end;
  line-height: 30px;
  background: #eaeaea;

  .navHeader_right {
    .dashoardPage {
      font-size: 15px;
      color: #999;
      margin-left: 50px;
      cursor: pointer;

      i.el-icon-s-home {
        font-size: 20px;
        vertical-align: revert;
        color: var(--main-theme-color);
        margin-right: 5px;
      }
    }

    button.el-button.el-button--default.el-button--mini {
      background: transparent;
      border: none;
      padding: 0;
      font-size: 14px;
      margin-right: 20px;
    }
  }

  .collectButoon {
    display: flex;
    width: 1200px;
    margin: auto;
    justify-content: space-between;

    i.el-icon-s-shop {
      font-size: 20px;
      vertical-align: middle;
      color: var(--main-theme-color);
    }

    /deep/ i.el-icon-star-on {
      font-size: 20px;
      color: var(--main-theme-color);
      vertical-align: middle;
    }

    /deep/ i.el-icon-star-off {
      font-size: 20px;
      vertical-align: middle;
    }
  }

  .el-dropdown {
    margin-right: 20px;
  }
}

.carouselBox {
  // width: 1600px;
  margin: auto;
  margin-bottom: 20px;
}

.carouselBox.el-carousel.el-carousel--horizontal {
  padding-right: 40px;
}

.labelTitle {
  text-align: left;
  padding-left: 15px;
  font-weight: bold;
  color: #666;
  font-size: 14px;
}

.labelcontent {
}

.fisrtNav {
  padding: 10px 0px;
  border-top: 1px dashed #ddd;
  border-bottom: 1px dashed #ddd;
  margin-bottom: 20px;
}

.leftaside {
  /* background: pink; */
  /* padding: 10px; */
  box-sizing: border-box;
  font-size: 14px;
  border: 1px solid #ddd;
  margin-right: 10px;
}

.leftaside h4 {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

.left_product {
  padding: 10px;
}

.left_product li {
  margin-bottom: 30px;
}

.pro-price {
  margin: 10px 0;
  color: var(--hover-color);
}

.pro_name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 14px;
  margin: 10px 0;
  height: 40px;
}

.img-responsive {
  /* width: 100%; */
  width: 200px;
  height: 200px;
}

.rightaside {
  /* background: yellow; */
  padding: 0px;
  box-sizing: border-box;
  overflow: hidden;
}

.el-header {
  height: auto !important;
}

/* 右边 */
.orderby {
  width: 100%;
  padding: 8px 0;
  background: #f1f1f1;
}

.orderby ul {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.orderby ul li {
  background: #fff;
  color: #333;
  margin-left: 10px;
  border: 1px solid #ddd;
  font-size: 12px;
  padding: 2px 15px;
  line-height: 20px;
}

.active a {
  color: white !important;
}

.orderby .el-checkbox__label {
  font-size: 12px !important;
}

.orderby .el-checkbox__input {
  vertical-align: bottom !important;
}

.right_product {
  padding: 20px;
}

.right_product .product_item {
  margin-bottom: 20px;
  border: 1px solid #fff;
  border-color: #e9e9e9;
  -webkit-box-shadow: 0 0 2px 2px #f8f8f8;
  box-shadow: 0 0 2px 2px #f8f8f8;
  padding: 10px;
  box-sizing: border-box;
}

.product_item:hover img {
  opacity: 0.7;
}

.pro_price_add {
  display: flex;
  justify-content: space-around;
}

.cart.add-to-cart,
div.now_price {
  flex: 1;
  font-weight: bold;
  border: 1px solid var(--border-color);
  padding: 8px 0;
  text-align: center;
}

/* .cart.add-to-cart:hover{
	border: 1px solid #f12b2d;
} */
div.now_price {
  color: white;
  background: var(--main-theme-color);
  border: 1px solid var(--border-color);
}

.dialog-footer {
  margin-top: 20px;
  display: block;
}

.addGoodsInfo {
  font-size: 24px;
}

.addCartBox .el-button--primary {
  color: #fff;
  background-color: #ff6700;
  border-color: #e65d00;
}

.more_filter {
  width: 100%;
  text-align: center;
  border-top: 1px dashed #ddd;
  margin-top: -1px;
}

.more_filter:hover {
  border-color: var(--hover-color);
}

.more_filter span {
  display: inline-block;
  height: 30px;
  line-height: 26px;
  margin-top: -1px;
  width: 130px;
  text-align: center;
  border-width: 1px;
  border-style: dashed;
  border-color: #fff #ddd #ddd;
  background: #fff;
  font-size: 12px;
  color: #939393;
  cursor: pointer;
}

.filter_con .more_filter span i {
  font-size: 12px;
}

.filter_con .more_filter:hover span {
  color: var(--main-theme-color);
  border-color: #fff var(--border-color) var(--border-color);;
}

.nodate {
  text-align: center;
  margin-top: 10%;
  margin-bottom: 10%;
  font-size: 16px;
}

.nodate .first {
  margin: 40 upx 0 12 upx;
  font-size: 28 upx;
}

/* top菜单 */
.categorys {
  float: left;
  width: 170px;
  height: 30px;
  position: relative;
}

.categorys-type {
  background-color: var(--main-theme-color);
  // text-align: center;
  margin-left: 50px;
  font-size: 0;
  line-height: 30px;
}

.categorys-type:hover {
  background: white;

  a {
    color: var(--main-theme-color) !important;
  }
}

.categorys-type a {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  display: block;

  i.el-icon-s-shop {
    font-size: 20px;
    vertical-align: middle;
  }
}

.nav-main {
  float: left;
  width: 968px;
  overflow: hidden;
  height: 30px;
  line-height: 30px;
}

.el-menu {
  background-color: var(--main-theme-color);
}

.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 30px;
  line-height: 30px;
  margin: 0;
  border-bottom: 2px solid transparent;
  color: white;

  i {
    color: #ffffff;
  }
}

.el-menu--horizontal > .el-menu-item:hover {
  i {
    color: var(--main-theme-color) !important;
  }
}

.el-menu-item:focus {
  i {
    color: var(--main-theme-color) !important;
  }
}

.categorysBox {
  position: relative;
  .stop-box{
    position: absolute;
    right: 80px;
    top: 60px;
    width: 150px;
    padding: 20px;
    text-align: center;
    font-weight: 500;
    border: 1px solid #ff751a;
    border-radius: 10px;
    background-color: #ff751a17;
    .el-icon-data-board{
      font-size: 20px;
    }
    &:after{
      content: '';
      display: block;
      height: 60px;
      border-right: 2px solid #ff751a;
      position: absolute;
      top: -60px;
      left: 50%;
    }
  }
  /* 分类表 */

  .categorys-tab-content {
    height: auto !important;
    padding: 15px 0;
    z-index: 30;
    background-color: #000;
    background-color: rgba(0, 0, 0, 0.6);
    /* bingo */
    display: block;
    position: relative;
  }

  .categorys-tab-content .categorys-items {
    position: relative;
    height: 100%;
  }

  .categorys-tab-content .categorys-item {
    cursor: pointer;
    height: 14.29%;
  }

  .categorys-tab-content .item-content {
    padding: 5px 16px;
    float: left;
    width: 200px;
  }

  .categorys-tab-content .item-content .icon-other {
    float: left;
    width: 18px;
    height: 18px;
  }

  .categorys-tab-content .item-content .icon-other img {
    width: 100%;
  }

  .categorys-tab-content .selected .item-content {
    background-color: rgba(0, 0, 0, 1);
  }

  .categorys-tab-content .iconfont {
    float: left;
    color: #bfbfbf;
  }

  .categorys-tab-content .categorys-title {
    float: left;
    margin-left: 10px;
    text-align: left;
  }

  .categorys-tab-content .categorys-title strong {
    display: block;
    font-weight: normal;
  }

  .categorys-tab-content .categorys-title strong a {
    color: #fff;
    font-size: 14px;
  }

  .categorys-tab-content .categorys-title span {
    display: block;
    font-size: 0;
  }

  .categorys-tab-content .categorys-title span a {
    color: #bfbfbf;
    margin-right: 10px;
    font-size: 14px;
  }

  .categorys-tab-content .categorys-title span a:hover,
  .categorys-tab-content .categorys-title strong a:hover {
    color: var(--border-color);
  }

  .categorys-items-layer {
    display: none;
    position: absolute;
    top: 0;
    left: 232px;
    width: 966px;
    min-height: 498px;
    border: 1px solid #fff;
    background-color: #fff;
    box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, .1);
    -webkit-transition: top .25s ease;
    transition: top .25s ease;

    .nodataCss {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 14px;
    }
  }
}

// 店铺活动
.bigoutBox {
  .wholeBox {
    display: flex;
    justify-content: flex-start;
    width: 280px;
    height: 126px;
    border: 1px solid #eaeaea;
    padding-right: 10px;
    margin-bottom: 20px;
    box-sizing: border-box;

    .el-button--text.is-disabled {
      color: #e4e7ed;
      background-color: #999;
    }
  }

  .img-Activity {
    width: 45%;
    padding: 10px;
    text-align: center;
    line-height: 100px;
  }

  .getNow {
    /* width: 132px;
    height: 40px; */
    margin-top: 1px;
    background-color: var(--main-theme-color);
    padding: 7px 15px;
    font-size: 15px;
    color: white;
  }


  .first {
    margin: 40upx 0 12upx;
    font-size: 28upx;
  }

  .second {
    font-size: 24upx;
    color: #999;
  }

  .nodate {
    text-align: center;
    margin-top: 10%;
    margin-bottom: 10%;
    font-size: 16px;
  }

  span.noimg {
    display: inline-block;
    width: 100%;
    background: #ccc;
  }
}

button.el-button.buttonBgd.el-button--primary {
  color: #fff;
  background-color:var(--main-theme-color);
  border-color: var(--border-color);
  width: 180px;
  margin-left: 12px;
  margin-top: 5px;
  font-size: 14px;
}

.dialogBox .textCenter {
  text-align: center !important;
  font-size: 24px !important;
}

.pagination {
  text-align: right;

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ff6700;
    color: #FFF;
    width: 20px;
  }

  /deep/ .el-pagination.is-background .btn-next, /deep/ .el-pagination.is-background .btn-prev, /deep/ .el-pagination.is-background .el-pager li {
    width: 20px;
  }

  /deep/ input[disabled], input[disabled="disabled"], input[readonly], input[readonly="readonly"] {
    background-color: transparent;
  }
}
</style>







// WEBPACK FOOTER //
// src/views/store/storeHome.vue